import React from 'react';
import { Navigate } from 'react-router-dom';
import { isAuthenticated, isAdmin } from '../utils/auth';
import SubscriptionGuard from './SubscriptionGuard';

interface ProtectedRouteProps {
  children: React.ReactNode;
  requireAdmin?: boolean;
  requireSubscription?: boolean;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
  children,
  requireAdmin: needsAdmin = false,
  requireSubscription = true
}) => {
  // Check if user is authenticated using the auth utility
  const authenticated = isAuthenticated();

  // If not authenticated, redirect to login
  if (!authenticated) {
    return <Navigate to="/login" replace />;
  }

  // If admin access is required but user is not admin
  if (needsAdmin && !isAdmin()) {
    return <Navigate to="/dashboard" replace />;
  }

  // Wrap with SubscriptionGuard to enforce subscription requirement
  return (
    <SubscriptionGuard requireSubscription={requireSubscription} showModal={true}>
      {children}
    </SubscriptionGuard>
  );
};

export default ProtectedRoute;
